module.exports = __webpack_public_path__ + "img/img_cx_big.65b62dd7.png";